import React,{useState, useEffect} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pager from './Pager';
import Ajax from './Ajax';
import {Inc,Story,ResultSet} from './Inc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MailIcon from '@material-ui/icons/Mail';
import Loading from './Loading';
import './Search.scss';

interface Props {
    uid:string,
    move(str:string,param?:any):void,
    save(id?:string):void,
}

const Search = (props:Props)=> {
    const defStorys:Story[] = [];
    const [states,setStates] = useState({
        storys: defStorys,
        last_id: 0,
        isLoading: true,
        count: 0,
        page: 1,
        sort: "id",
        asc: false,
        per:10,
    })
    const play = (event: React.MouseEvent<HTMLElement>)=>{
        if( !event.currentTarget.dataset.index ){
            return;
        }
        const index = parseInt(event.currentTarget.dataset.index);

        setStates({...states,isLoading:true});
        Ajax.send("play/add",{id:states.storys[index].id},(res:any)=>{
            if( res.ok ){
                const result:ResultSet = {
                    story: states.storys[index],
                    play: res.play,
                    is_suki: false,
                }
                if( res.uid && res.uid!=="" && res.uid!==props.uid ){
                    props.save(res.uid);
                }
                props.move("board",result);
            }
        })
    }
    const caret = (name:string,key:string)=>{
        return (
            <span onClick={changeCaret} data-id={key} className="caret">
                {name}
                {states.sort===key && states.asc &&
                    <FontAwesomeIcon icon="caret-up" style={{marginLeft:"0.5em",color:"white"}}/>
                }
                {states.sort===key && !states.asc &&
                    <FontAwesomeIcon icon="caret-down" style={{marginLeft:"0.5em",color:"white"}}/>
                }
            </span>
        )
    };
    const changeCaret = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.id ){
            let asc = states.asc;
            if( states.sort===e.currentTarget.dataset.id ){
                asc = !asc;
            }
            setStates({...states,sort:e.currentTarget.dataset.id,asc:asc,page:1});
        }
    }
    const changePage = (newPage: number)=>{
        console.log("change_page",newPage);
        const el = document.getElementById("search");
        if( el ){
            el.scrollTo(0,0);
        }  
        setStates({...states,page:newPage});
    }
    const update = ()=>{
        setStates({...states,isLoading:true});
        Ajax.send("story/list",{page:states.page,sort:states.sort,asc:states.asc,per:states.per},(res:any)=>{
            if( res.ok ){
                //setStates({...states,"isLoading":false,"storys":states.storys.concat(res.storys)});
                setStates({...states,"isLoading":false,"storys":res.storys,"count":res.count});
            }
        })
    }

    useEffect( ()=>{
        update();
    },[states.page,states.sort,states.asc])

    return (
		<div id="search" className="root">
            <Table size="small" style={{marginTop:"1em"}}>
                <TableHead>
                    <TableRow>
                        <TableCell className="cell cell-dense nowrap" align="center">
                            {caret("新旧","id")}
                        </TableCell>
                        <TableCell className="cell nowrap">
                            {caret("タイトル/ジャンル","title")}
                        </TableCell>
                        <TableCell className="cell nowrap" align="right">
                            {caret("スキ","suki")}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {states.storys.map((story:Story,index:number)=>{
                    const key = "story"+index;
                    return (
                        <TableRow key={key} onClick={play} data-index={index}>
                            <TableCell className="cell cell-dense" align="center"><MailIcon /></TableCell>
                            <TableCell className="cell">
                                {story.title}<br/>
                                <span className="group">{Inc.groupNames[story.group_id]} （{story.moji}字）</span>
                            </TableCell>
                            <TableCell className="cell nowrap" align="right">
                                <span className="suki"><FontAwesomeIcon icon="heart"/> {story.suki}</span>
                            </TableCell>
                        </TableRow>
                    )
                })}
                </TableBody>
            </Table>
            <div className="pagination">
                <Pager
                    count={states.count}
                    perPage={states.per}
                    page={states.page}
                    changePage={changePage}
                />
            </div>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default Search;